import * as React from 'react';
import { translate } from 'secullum-i18n';
import { Subscribe } from 'unstated';
import { FuncionarioContainer } from '../../../shared/containers/FuncionarioContainer';
import { retornarRotaWeb, Telas } from '../../../shared/modules/telas';
import CardVenderFerias from '../../../shared/screens/ferias/CardVenderFerias';
import LoggedInScreen from '../../components/LoggedInScreen';
import { RouteComponentComBancoIdProps, navegar } from '../../modules/routes';

interface Props extends RouteComponentComBancoIdProps {}

class VenderFerias extends React.Component<Props> {
  voltarParaFerias = () => {
    navegar({
      props: this.props,
      path: retornarRotaWeb(Telas.Ferias)
    });
  };

  render() {
    return (
      <LoggedInScreen screenTitle={translate('Vender Férias')}>
        <Subscribe to={[FuncionarioContainer]}>
          {(funcionario: FuncionarioContainer) => (
            <CardVenderFerias
              dados={funcionario.state.dados}
              onConcluir={this.voltarParaFerias}
              onCancelar={this.voltarParaFerias}
            />
          )}
        </Subscribe>
      </LoggedInScreen>
    );
  }
}

export default VenderFerias;
